export const APP_PATHS = {
  home: '/',
  events: '/events',
  volunteer: '/volunteer',
  gallery: '/gallery',
  calendar: '/calendar',
  help: '/help',
  feedback: '/feedback',
  fundraising: '/fundraising',
  about: '/about',
  secureHandlingPolicy: '/secure-handling-policy',
  pvg: '/pvg-membership',
  referralPolicy: '/referral-policy',
};
